import { SalesReportGraphData } from '../../../types/salesReportGraphData'

// Returns a rounded max domain value for the graph based on paid + unpaid totals
export const getGraphDomain = (graphData: SalesReportGraphData[]): [0, number] => {
  // Find the highest monthly total (paid + unpaid) across all months
  const maxMonthlyTotal = Math.floor(Math.max(...graphData.map(({ values }) => values.paid + values.unpaid), 0))

  if (maxMonthlyTotal === 0) {
    return [0, 1]
  }

  // Determine the order of magnitude of the maximum value (e.g. 1234 -> 1000)
  const magnitude = 10 ** Math.floor(Math.log10(maxMonthlyTotal))

  // Round the max value up to the nearest magnitude (e.g. 1234 -> 2000)
  const roundedMaxValue = Math.ceil(maxMonthlyTotal / magnitude) * magnitude

  return [0, roundedMaxValue]
}
